module.exports = __webpack_public_path__ + "images/shortlease_small242f06d8699e1be3774dca95c4a67b91.png";